// extracted by mini-css-extract-plugin
export default {"items_detail":"ItemsDetail_items_detail__+L7Tk"};